import * as contentful from 'contentful';
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Loader } from '../Components/Loader';
import { useBrandDetails } from 'dw-au-react-components';
import GoogleAnalytics from '../Utils/ObjectUtils/GoogleAnalytics';
import CreateEcommerceItem from '../Utils/ObjectUtils/CreateEcommerceItem';

export const ContentfulContext = createContext();

export const ContentfulProvider = (props) => {
	const brandData = useBrandDetails();
	const getEnv = () => {
		if (
			location.host.indexOf('localhost') > -1 ||
			location.host.indexOf('webdev00') > -1 ||
			location.host.indexOf('rebrand.') > -1 ||
			location.host.indexOf('st.') > -1 ||
			location.host.indexOf('uat.') > -1
		) {
			return 'uat';
		} else {
			return 'live';
		}
	};

	let currentEnv = getEnv();

	const client = contentful.createClient({
		space: '759ah7skns84',
		accessToken: 'WRSJ8s9akgwwr-ejARj8VUrKv67gUu8NhjnhYZu35-0',
		// space: currentEnv === 'live' ? '759ah7skns84' : 'fwmimfxysb9y',
		// accessToken:
		// 	currentEnv === 'live'
		// 		? 'WRSJ8s9akgwwr-ejARj8VUrKv67gUu8NhjnhYZu35-0'
		// 		: 'hshwZYDAMz5kvu2Vja8FKtE1qoZDl-MYtNHM2eFn4n4',
	});

	const [loading, setLoading] = useState(true);
	const [entries, setEntries] = useState(null);
	const [lpDefaults, setLpDefaults] = useState({});
	const [products, setProducts] = useState(null);
	const [freeItem, setFreeItem] = useState(null);
	const [freeItems, setFreeItems] = useState(null);
	const [allowExistingCustomer, setAllowExistingCustomer] = useState(true);
	const [showVouchers, setShowVouchers] = useState(false);
	const [offerThirdParty, setOfferThirdParty] = useState(null);
	const [showThirdParty, setShowThirdParty] = useState(false);
	const [onePageCheckOut, setOnePageCheckOut] = useState(false);

	const [showModal, setShowModal] = useState(false);
	const [caseItems, setCaseItems] = useState([]);
	const [modalLoading, setModalLoading] = useState(false);
	const [modalItemCode, setModalItemCode] = useState(null);

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	const getCaseContents = (itemCode) => {
		toggleModal();
		setModalItemCode(itemCode);

		// view_item fires when an individual case's details are viewed
		const viewed = (products || []).find(
			(mi) => mi?.product?.itemCode === itemCode
		);
		if (viewed?.product) {
			const viewItem = CreateEcommerceItem(viewed.product);
			GoogleAnalytics.setEcommerce('view_item', [viewItem]);
		}

		if (!caseItems.some((item) => item.itemCode === itemCode)) {
			setModalLoading(true);
			axios
				.get('/api/product/case/' + itemCode)
				.then((response) => {
					setModalLoading(false);
					let data = response.data.response;
					if (data?.contentProducts.length > 0) {
						setCaseItems([
							...caseItems,
							{ itemCode, content: data.contentProducts },
						]);
					}
				})
				.catch(() => {});
		}
	};
	const preloadCaseContents = (itemCode) => {
		if (caseItems.some((item) => item.itemCode === itemCode)) return;
		axios
			.get(`/api/product/case/${itemCode}`)
			.then((response) => {
				const data = response?.data?.response;
				if (
					Array.isArray(data?.contentProducts) &&
					data.contentProducts.length > 0
				) {
					setCaseItems((prev) => [
						...prev,
						{ itemCode, content: data.contentProducts },
					]);
				}
			})
			.catch((error) => {
				console.error(`Error preloading case contents for ${itemCode}:`, error);
			});
	};

	useEffect(() => {
		fetchContentfulData();
		fetchLpDefaults();
	}, []);

	let search, searchParams, lpName;
	(search = window.location.search.slice(1).split('&')),
		(searchParams = search.filter((item) => item.indexOf('promoCode=') > -1));

	if (searchParams.length > 0) {
		lpName = searchParams[0].split('promoCode=')[1];
	}

	const params = {
		content_type: 'dmLandingPageLpPageBuilder',
	};
	params['include'] = 2;
	params['fields.slug'] = lpName;
	params['fields.brand[match]'] = brandData.tag;

	const fetchContentfulData = () => {
		setLoading(true);

		client
			.getEntries(params)
			.then((response) => {
				if (response?.items[0]?.fields?.title) {
					setEntries(response);
					fetchProducts(response);
				} else if (currentEnv === 'live') {
					location.href = '/jsp/ExpiryPage.jsp';
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const fetchLpDefaults = () => {
		client
			.getEntries({
				content_type: 'siteConfig',
				'fields.brand': brandData.tag,
			})
			.then((response) => {
				if (response?.items) {
					setLpDefaults(response?.items[0]?.fields || {});
				}
			})
			.catch(() => {});
	};

	const fetchProducts = (response) => {
		let itemCode =
				response?.items[0]?.fields?.promoCode ??
				response?.items[0]?.fields?.promoCodeANI,
			freeItemItemCode = response?.items[0]?.fields?.freeItemItemCode;

		if (itemCode) {
			axios
				.get('/api/offer/' + itemCode)
				.then((response) => {
					const {
						data: {
							response: {
								businessPartner = {},
								mainItems,
								freeItems,
								offerContent,
							},
						},
					} = response;

					if (
						(response?.data?.response?.state === 'EXPIRED' &&
							currentEnv === 'live') ||
						(mainItems || []).length === 0
					) {
						location.href = '/jsp/ExpiryPage.jsp';
						return;
					}

					setProducts(mainItems);
					setFreeItems(freeItems);
					setAllowExistingCustomer(offerContent?.allowExistingCustomer);
					setOnePageCheckOut(offerContent?.onePageCheckOut);
					setShowThirdParty(offerContent?.showThirdParty);
					setShowVouchers(offerContent?.showVouchers);
					setOfferThirdParty(businessPartner?.name);

					if (freeItemItemCode) {
						fetchFreeItem(freeItemItemCode);
					} else {
						setLoading(false);
					}
				})
				.catch(() => {
					if (currentEnv === 'live') {
						location.href = '/jsp/ExpiryPage.jsp';
					}
					// setLoading(false);
				});
		} else {
			setLoading(false);
		}
	};

	const fetchFreeItem = (itemCode) => {
		axios
			.get('/api/product/item/' + itemCode)
			.then((response) => {
				setFreeItem(response?.data?.response);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	return (
		<ContentfulContext.Provider
			value={{
				entries,
				products,
				freeItems,
				freeItem,
				allowExistingCustomer,
				onePageCheckOut,
				showThirdParty,
				offerThirdParty,
				showVouchers,
				lpDefaults,
				fetchContentfulData,
				getCaseContents, // for modal
				preloadCaseContents, // for preloading
				toggleModal,
				showModal,
				caseItems,
				modalLoading,
				modalItemCode,
			}}
		>
			{loading ? <Loader /> : props.children}
		</ContentfulContext.Provider>
	);
};
